import {
  PARENT_BRAND_LOGO_SRC,
  PARENT_BRAND_NAME,
  PARENT_BRAND_URL,
  PRODUCT_NAME,
} from "@/lib/brand";
import { Link } from "react-router-dom";

export function BrandLogo({
  href = "/",
  size = 36,
  showWordmark = true,
  showParentBrand = true,
}: {
  href?: string;
  size?: number;
  showWordmark?: boolean;
  showParentBrand?: boolean;
}) {
  return (
    <div className="inline-flex min-w-0 items-center gap-2.5 sm:gap-3">
      <Link
        to={href}
        className="group inline-flex min-w-0 items-center gap-2.5 rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700"
      >
        <img
          src="/prime-assistant-logo.svg"
          alt=""
          width={size}
          height={size}
          className="shrink-0 drop-shadow-sm transition-transform duration-300 group-hover:scale-[1.04]"
        />
        {showWordmark ? (
          <span className="truncate font-[family-name:var(--font-display)] text-lg font-semibold tracking-tight text-slate-900">
            {PRODUCT_NAME}
          </span>
        ) : null}
        <span className="sr-only">{PRODUCT_NAME} home</span>
      </Link>
      {showParentBrand ? (
        <>
          <span
            className="hidden h-5 w-px shrink-0 bg-slate-300/80 sm:block"
            aria-hidden
          />
          <a
            href={PARENT_BRAND_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex shrink-0 items-center gap-1.5 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700"
            title={`A ${PARENT_BRAND_NAME} property — opens in a new tab`}
          >
            <span className="hidden text-[10px] font-medium uppercase tracking-[0.06em] text-slate-500 sm:inline">
              A property of
            </span>
            <img
              src={PARENT_BRAND_LOGO_SRC}
              alt={PARENT_BRAND_NAME}
              width={120}
              height={23}
              className="h-3.5 w-auto opacity-90 transition-opacity hover:opacity-100 sm:h-4"
            />
          </a>
        </>
      ) : null}
    </div>
  );
}
